import React from 'react';
import classNames from 'classnames';
import { createUseStyles } from 'react-jss';
import TickIcon from './icons/TickIcon';
import { Colours } from '../tokens';
const useStyles = createUseStyles(() => ({
    root: {
        cursor: 'pointer',
        position: 'relative',
        display: 'flex',
        '&:hover': {
            backgroundColor: Colours.septernary,
        },
    },
    label: {
        appearance: 'none',
        cursor: 'pointer',
        outline: 'none',
        width: 16,
        height: 16,
        borderRadius: '3px',
        border: `2px solid ${Colours.primary}`,
    },
    hidden: {
        display: 'none',
    },
    disabled: {
        opacity: 0.5,
        cursor: 'initial',
    },
    icon: {
        position: 'absolute',
        top: 2,
        left: 2,
        height: 12,
        width: 12,
        color: 'transparent',
    },
    checked: {
        backgroundColor: Colours.primary,
        color: Colours.white,
    },
}));
function Checkbox({ id, checked = false, disabled = false, onChange, required = false, }) {
    const classes = useStyles();
    return (React.createElement("div", { role: "button", tabIndex: 0, onClick: disabled ? () => { } : onChange, onKeyPress: disabled ? () => { } : onChange, className: classNames(classes.root, disabled && classes.disabled) },
        React.createElement("input", { id: id, name: id, readOnly: true, checked: checked, required: required, disabled: disabled, type: "checkbox", className: classes.hidden }),
        React.createElement("label", { className: classNames(classes.label), htmlFor: id }),
        React.createElement(TickIcon, { className: classNames(classes.icon, checked && classes.checked) })));
}
export default Checkbox;
//# sourceMappingURL=Checkbox.js.map